import "./vto.scss";
import {
	VCol,
	VRow
} from "vuetify/lib";

export default {
	name: "traction",

	props: { vto: Object },

	render() {
		return <VCol>
			<VRow class="text-h3 text-center">
				TRACTION
			</VRow>

			<VRow class="vto-section">
				<VCol class="vto-section__header"cols={4}>
					1-YEAR PLAN
				</VCol>

				<VCol class="vto-section__content" cols={8}>
					<div domPropsInnerHTML={this.vto.oneYearPlan}></div>
				</VCol>
			</VRow>

			<VRow class="vto-section">
				<VCol class="vto-section__header" cols={4}>
					ROCKS
				</VCol>

				<VCol class="vto-section__content"cols={8}>
					<div domPropsInnerHTML={this.vto.rocks}></div>
				</VCol>
			</VRow>

			<VRow class="vto-section">
				<VCol class="vto-section__header" cols={4}>
					ISSUES LIST
				</VCol>

				<VCol class="vto-section__content" cols={8}>
					<div domPropsInnerHTML={this.vto.issuesList}></div>
				</VCol>
			</VRow>
		</VCol>;
	}
};
